import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import util from "../util/util";
import ReportsSearchDate from "./reports-search-date";
import DatePicker from "react-datepicker";
import moment from "moment";

export default function ReportsSearchForm(props) {
  // search field name;
  const [field, setField] = useState(``);
  // search string value;
  const [search, setSearch] = useState(``);
  const [start, setStart] = useState(moment(new Date()));
  const [end, setEnd] = useState(moment(new Date()));
  // PDF Invoice data
  const [showPdfForm, setShowPdfForm] = useState(false);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [invoiceDate, setInvoiceDate] = useState(moment(new Date()));
  const [invoiceDescription, setInvoiceDescription] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  const [companyCity, setCompanyCity] = useState("");
  const [costPerView, setCostPerView] = useState("");
  const [podsOrderedByDate, setPodsOrderedByDate] = useState(true);
  const [podsOrderedByName, setPodsOrderedByName] = useState(false);
  const [columnsToIncludeAirtime, setColumnsToIncludeAirtime] = useState(true);
  const [columnsToIncludePodName, setColumnsToIncludePodName] = useState(true);
  const [columnsToIncludeShownAfter, setColumnsToIncludeShownAfter] = useState(
    true
  );
  const [
    columnsToIncludeShownBefore,
    setColumnsToIncludeShownBefore
  ] = useState(true);
  const [columnsToIncludeViewCount, setColumnsToIncludeViewCount] = useState(
    true
  );

  useEffect(() => {
    setField(props.field);
    setSearch(props.search);
    setStart(props.start ? moment(props.start) : moment());
    setEnd(props.end ? moment(props.end) : moment());
  }, [props]);

  // if the key pressed is `enter` then submit the search form;
  const onKeyPress = e => {
    if (e.key === `Enter`) {
      onSearchSubmit();
    }
  };

  // go to a new URL with the selected form values;
  const onSearchSubmit = () => {
    let url = `${util.returnReportsUrl()}?`;

    url = `${url}field=${field}`;
    url = `${url}&search=${encodeURIComponent(search.trim())}`;
    url = `${url}&start=${start.format(util.dateFormatComputer)}`;
    url = `${url}&end=${end.format(util.dateFormatComputer)}`;

    const params = {
      url: url,
      field: field,
      search: search,
      start: start,
      end: end
    };

    props.searchSubmit(params);
  };

  return (
    <div>
      <div className="form-inline search-form">
        <div className="form-group">
          <label htmlFor="search-form__field">Field:</label>
          <select
            id="search-form__field"
            className="form-control"
            value={field}
            onChange={e => setField(e.target.value)}
          >
            <option value="">-----</option>
            {util.podElementFields.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <input
            type="text"
            id="search-form__search"
            className="form-control"
            value={search}
            autoFocus
            onChange={e => setSearch(e.target.value)}
            onKeyPress={e => onKeyPress(e)}
          />
        </div>

        <div className="form-group">
          <label>From</label>
          <div className="reports__button--date">
            <DatePicker
              popperClassName="reports__datepicker"
              customInput={
                <ReportsSearchDate
                  dateDisplay={start.format(util.dateFormatHumanLong)}
                />
              }
              fixedHeight
              selected={start}
              selectsStart
              startDate={start}
              endDate={end}
              onChange={value => {
                const newStart = value;
                let newEnd = end;

                if (newStart.isSame(end) === false) {
                  if (newStart.isAfter(end)) {
                    newEnd = value;
                  }
                }
                setEnd(newEnd);
                setStart(newStart);
              }}
            />
          </div>
        </div>

        <div className="form-group">
          <label>To</label>
          <div className="reports__button--date">
            <DatePicker
              popperClassName="reports__datepicker"
              customInput={
                <ReportsSearchDate
                  dateDisplay={end.format(util.dateFormatHumanLong)}
                />
              }
              fixedHeight
              selected={end}
              selectsEnd
              startDate={start}
              endDate={end}
              onChange={value => {
                let newStart = start;
                const newEnd = value;

                if (start.isSame(newEnd) === false) {
                  if (start.isAfter(newEnd)) {
                    newStart = value;
                  }
                }
                setEnd(newEnd);
                setStart(newStart);
              }}
            />
          </div>
        </div>

        <div className="search-form__buttons search-form__buttons--block">
          <div className="search-form__buttons">
            <button
              className="btn btn-default"
              disabled={field.length > 1 && search.length < 1}
              onClick={() => onSearchSubmit()}
            >
              <i className="fa fa-search" aria-hidden="true"></i>
              Generate Report
            </button>
          </div>
        </div>
      </div>

      <div className="row reports__button--download">
        <div className="col-xs-1 col-sm-6 text-right">
          <p>
            <a
              href={util.getReportsCSV({
                field: field,
                end: end.format(util.dateFormatComputer),
                search: encodeURIComponent(search.trim()),
                start: start.format(util.dateFormatComputer)
              })}
              className={
                field.length > 1 && search.length < 1
                  ? `btn btn-default disabled`
                  : `btn btn-default`
              }
            >
              <i className="fa fa-cloud-download" aria-hidden="true"></i>
              Download CSV
            </a>
          </p>
        </div>

        <div className="col-xs-12 col-sm-6">
          <button
            className="btn btn-default"
            disabled={field.length > 1 && search.length < 1}
            onClick={() => setShowPdfForm(!showPdfForm)}
          >
            <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
            Create PDF Invoice
          </button>
        </div>
      </div>

      <div className={showPdfForm ? "form-inline search-form" : "hidden"}>
        <h5 className="page__header col-sm-12"> Invoice Details </h5>
        <div className="row">
          <div className="col-sm-3 col-sm-offset-1">
            <div className="form-group form-inline">
              <label className="control-label" htmlFor="invoiceNumber">
                Invoice Number: &nbsp;
              </label>
              <input
                type="text"
                id="invoiceNumber"
                className="form-control reports__pdf--input--width--small"
                value={invoiceNumber}
                autoFocus
                onChange={e => setInvoiceNumber(e.target.value)}
                maxLength="50"
                placeholder=""
              />
            </div>
          </div>
          <div className="col-sm-4">
            <div className="form-group">
              <label className="control-label" htmlFor="invoiceDate">
                Invoice Date: &nbsp;
              </label>
              <div className="reports__button--date">
                <DatePicker
                  popperClassName="reports__datepicker"
                  customInput={
                    <ReportsSearchDate
                      dateDisplay={invoiceDate.format(util.dateFormatHumanLong)}
                    />
                  }
                  fixedHeight
                  selected={invoiceDate}
                  onChange={value => setInvoiceDate(value)}
                />
              </div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="form-group form-inline">
              <label className="control-label" htmlFor="invoiceDescription">
                Invoice Description: &nbsp;
              </label>
              <input
                type="text"
                id="invoiceDescription"
                className="form-control reports__pdf--input--width--large"
                value={invoiceDescription}
                autoFocus
                onChange={e => setInvoiceDescription(e.target.value)}
                maxLength="300"
                placeholder="Pods, Campaigns"
              />
            </div>
          </div>
        </div>

        <hr />

        <h5 className="page__header col-sm-12"> Sponsor Details </h5>
        <div className="row">
          <div className="col-sm-5 col-sm-offset-1">
            <div className="form-group form-inline">
              <label className="control-label" htmlFor="customerName">
                Contact Name: &nbsp;
              </label>
              <input
                type="text"
                id="customerName"
                className="form-control reports__pdf--input--width--large"
                value={customerName}
                autoFocus
                onChange={e => setCustomerName(e.target.value)}
                maxLength="100"
                placeholder=""
              />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group form-inline">
              <label className="control-label" htmlFor="companyName">
                Company Name: &nbsp;
              </label>
              <input
                type="text"
                id="companyName"
                className="form-control reports__pdf--input--width--large"
                value={companyName}
                autoFocus
                onChange={e => setCompanyName(e.target.value)}
                maxLength="100"
                placeholder=""
              />
            </div>
          </div>
        </div>
        <div className="form-group"></div>
        <div className="row">
          <div className="col-sm-5 col-sm-offset-1">
            <div className="form-group form-inline">
              <label className="control-label" htmlFor="companyAddress">
                Street Address: &nbsp;
              </label>
              <input
                type="text"
                id="companyAddress"
                className="form-control reports__pdf--input--width--large"
                value={companyAddress}
                autoFocus
                onChange={e => setCompanyAddress(e.target.value)}
                maxLength="150"
                placeholder="Street"
              />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group form-inline">
              <label className="control-label" htmlFor="companyCity">
                City, State, Zip: &nbsp; &nbsp; &nbsp;
              </label>
              <input
                type="text"
                id="companyCity"
                className="form-control reports__pdf--input--width--large"
                value={companyCity}
                autoFocus
                onChange={e => setCompanyCity(e.target.value)}
                maxLength="150"
                placeholder="City, State, Zipcode"
              />
            </div>
          </div>
        </div>

        <hr />

        <h5 className="page__header col-sm-12"> Additional Details </h5>
        <div className="row">
          <div className="col-sm-6">
            <div className="row">
              <div className="col-sm-10 col-sm-offset-2">
                <div className="form-group form-inline">
                  <label className="control-label" htmlFor="costPerView">
                    Cost per impression:
                  </label>
                  <input
                    type="text"
                    id="costPerView"
                    className="form-control reports__pdf--input--width--small"
                    value={costPerView}
                    autoFocus
                    onChange={e => setCostPerView(e.target.value)}
                    maxLength="10"
                    placeholder="$"
                  />
                </div>
              </div>
            </div>
            <div className="form-group"></div>
            <div className="row">
              <div className="col-sm-10 col-sm-offset-2">
                <strong>Pods Ordered By:</strong>
              </div>
            </div>
            <div className="form-group"></div>
            <div className="row">
              <div className="col-sm-9 col-sm-offset-3">
                <div className="radio">
                  <label>
                    <input
                      type="radio"
                      name="podsOrderedBy"
                      id="podsOrderedByDate"
                      value="podsOrderedByDate"
                      checked={podsOrderedByDate === true}
                      onChange={e => {
                        setPodsOrderedByDate(e.target.checked);
                        setPodsOrderedByName(!e.target.checked);
                      }}
                    />{" "}
                    &nbsp; Date
                  </label>
                </div>
              </div>
            </div>
            <div className="form-group"></div>
            <div className="row">
              <div className="col-sm-9 col-sm-offset-3">
                <div className="radio">
                  <label>
                    <input
                      type="radio"
                      name="podsOrderedBy"
                      id="podsOrderedByName"
                      value="podsOrderedByName"
                      checked={podsOrderedByName === true}
                      onChange={e => {
                        setPodsOrderedByName(e.target.checked);
                        setPodsOrderedByDate(!e.target.checked);
                      }}
                    />{" "}
                    &nbsp; Pod Name
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="row">
              <div className="col-sm-12">
                <strong>Columns To Include:</strong>
              </div>
            </div>
            <div className="form-group"></div>
            <div className="row">
              <div className="col-sm-11 col-sm-offset-1">
                <div className="checkbox">
                  <label className="checkbox-inline">
                    <input
                      type="checkbox"
                      name="columnsToInclude"
                      id="columnsToIncludeAirtime"
                      value="columnsToIncludeAirtime"
                      disabled={true}
                      checked={columnsToIncludeAirtime === true}
                      onChange={e =>
                        setColumnsToIncludeAirtime(e.target.checked)
                      }
                    />{" "}
                    &nbsp; Airtime &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    &nbsp;
                  </label>
                  <label className="checkbox-inline">
                    <input
                      type="checkbox"
                      name="columnsToInclude"
                      id="columnsToIncludePodName"
                      value="columnsToIncludePodName"
                      checked={columnsToIncludePodName === true}
                      onChange={e =>
                        setColumnsToIncludePodName(e.target.checked)
                      }
                    />{" "}
                    &nbsp; Pod Name
                  </label>
                </div>
              </div>
            </div>
            <div className="form-group"></div>
            <div className="row">
              <div className="col-sm-11 col-sm-offset-1">
                <div className="checkbox">
                  <label className="checkbox-inline">
                    <input
                      type="checkbox"
                      name="columnsToInclude"
                      id="columnsToIncludeShownAfter"
                      value="columnsToIncludeShownAfter"
                      checked={columnsToIncludeShownAfter === true}
                      onChange={e =>
                        setColumnsToIncludeShownAfter(e.target.checked)
                      }
                    />{" "}
                    &nbsp; Shown After &nbsp; &nbsp; &nbsp;
                  </label>
                  <label className="checkbox-inline">
                    <input
                      type="checkbox"
                      name="columnsToInclude"
                      id="columnsToIncludeShownBefore"
                      value="columnsToIncludeShownBefore"
                      checked={columnsToIncludeShownBefore === true}
                      onChange={e =>
                        setColumnsToIncludeShownBefore(e.target.checked)
                      }
                    />{" "}
                    &nbsp; Shown Before
                  </label>
                </div>
              </div>
            </div>
            <div className="form-group"></div>
            <div className="row">
              <div className="col-sm-11 col-sm-offset-1">
                <div className="checkbox">
                  <label>
                    <input
                      type="checkbox"
                      name="columnsToInclude"
                      id="columnsToIncludeViewCount"
                      value="columnsToIncludeViewCount"
                      checked={columnsToIncludeViewCount === true}
                      onChange={e =>
                        setColumnsToIncludeViewCount(e.target.checked)
                      }
                    />{" "}
                    &nbsp; Impressions
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr />

        <div className="row">
          <div className="col-sm-12 text-center">
            <p>
              <a
                href={util.getReportsPDF({
                  field: field,
                  search: encodeURIComponent(search.trim()),
                  start: start.format(util.dateFormatComputer),
                  end: end.format(util.dateFormatComputer),
                  invoiceNumber: encodeURIComponent(invoiceNumber.trim()),
                  invoiceDate: invoiceDate.format(util.dateFormatComputer),
                  customerName: encodeURIComponent(customerName.trim()),
                  companyName: encodeURIComponent(companyName.trim()),
                  companyAddress: encodeURIComponent(companyAddress.trim()),
                  companyCity: encodeURIComponent(companyCity.trim()),
                  invoiceDescription: encodeURIComponent(
                    invoiceDescription.trim()
                  ),
                  costPerView: encodeURIComponent(costPerView.trim()),
                  podsOrderedByDate: podsOrderedByDate,
                  podsOrderedByName: podsOrderedByName,
                  columnsToIncludeAirtime: columnsToIncludeAirtime,
                  columnsToIncludePodName: columnsToIncludePodName,
                  columnsToIncludeShownAfter: columnsToIncludeShownAfter,
                  columnsToIncludeShownBefore: columnsToIncludeShownBefore,
                  columnsToIncludeViewCount: columnsToIncludeViewCount
                })}
                className={
                  field.length > 1 && search.length < 1
                    ? `btn btn-default disabled`
                    : `btn btn-default`
                }
              >
                <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                Download PDF Invoice
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

ReportsSearchForm.propTypes = {
  search: PropTypes.string,
  field: PropTypes.string,
  searchSubmit: PropTypes.func
};
